function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M24 12c0 6.629-5.372 12-12 12S0 18.629 0 12C0 5.374 5.372 0 12 0s12 5.374 12 12z",
  fill: "#E98061"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.098 16.196c-.268 0-.537-.102-.742-.308l-2.848-2.847a1.049 1.049 0 010-1.485 1.049 1.049 0 011.484 0l2.106 2.105 4.954-4.953a1.05 1.05 0 011.484 1.486l-5.695 5.694a1.047 1.047 0 01-.743.308z",
  fill: "#E98061"
});
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
}
export default SvgCheck;